import * as React from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { useTranslation } from 'react-i18next'

import { MultilineParagraph } from '../../Styles'

const tes = require('../../locales/en/testimonials.json')

export default function TestimonialsList() {
  const { t } = useTranslation()

  const primaryColor = '#2E3B55' // 너의 헤더 컬러 기반
  const hoverColor = '#e55955' // 호버 시 변경될 색상

  const CardBox = ({ name, fname, title }) => (
    <Card
      sx={{
        mb: 2,
        pl: 2,
        pr: 2,
        py: 2,
        borderLeft: `5px solid ${primaryColor}`,
        boxShadow: 3,
        borderRadius: 2,
        backgroundColor: '#fff',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          borderLeft: `5px solid ${hoverColor}`,
          boxShadow: 4
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Typography
          sx={{
            color: primaryColor,
            fontSize: '30px',
            fontWeight: 'bold',
            lineHeight: 1,
            mr: 1
          }}
        >
          "
        </Typography>

        <Box>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            textAlign="left"
            sx={{ lineHeight: 1.2 }}
          >
            {name}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            textAlign="left"
            sx={{ fontStyle: 'italic' }}
          >
            {title}
          </Typography>
        </Box>
      </Box>

      <CardContent sx={{ pt: 0 }}>
        <Typography
          variant="body2"
          color="text.primary"
          sx={{ whiteSpace: 'pre-line', textAlign: 'left' }}
        >
          <MultilineParagraph lines={t(`testimonials:${fname}.lines`)} />
        </Typography>
      </CardContent>
    </Card>
  )

  return (
    <Container
      maxWidth="md"
      disableGutters
      sx={{ mt: 2, px: 0 }}
    >
      <CardBox name={tes.jacob.name} fname="jacob" title={tes.jacob.title} />
      <CardBox name={tes.joe.name} fname="joe" title={tes.joe.title} />
      <CardBox name={tes.dan.name} fname="dan" title={tes.dan.title} />
      <CardBox name={tes.john.name} fname="john" title={tes.john.title} />
      <CardBox name={tes.jeff.name} fname="jeff" title={tes.jeff.title} />
      <CardBox name={tes.steven.name} fname="steven" title={tes.steven.title} />
      <CardBox name={tes.ming.name} fname="ming" title={tes.ming.title} />
    </Container>
  )
}
